import React, { lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";
// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
//import ForgotPassword from "../components/ForgotPassword/ForgotPassword";
const ForgotPassword = lazy(() =>
  import(
    /* webpackChunkName: "ForgotPassword" */ "../components/ForgotPassword/ForgotPassword"
  )
);

// redux stuff
import { connect } from "react-redux";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
}));

function forgotPassword() {
  const { classes } = useStyles();
  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Forgot Password - Content Generator Account Recovery`}
        description={`Securely reset your Content Generator password. Quick and easy account recovery process to get you back to creating social media marketing content.`}
        url={`https://contentgenerator.io/forgot-password`}
      />
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <ForgotPassword />
        </Suspense>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(forgotPassword);
